<template>
  <div class="custom-table-wrapper custom-wrapper">
    <el-table
      :data="data"
      :size="size"
      v-loading="loading"
      style="width: 100%;"
      :row-style="tableRowStyle"
      @selection-change="onSelectionChange"
      @sort-change="onSortChange" >
      <slot />
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  SET_PAGE,
  SET_PAGE_SIZE,
  SET_SORT,
  SET_LOADING,
  SET_FILTERS
} from '@/store/modules/table'

export default {
  name: 'CustomTable',
  props: {
    data: {
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    fetch: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('table', [
      'sort',
      'loading'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_PAGE_SIZE,
      SET_SORT,
      SET_LOADING,
      SET_FILTERS
    ]),
    onSelectionChange (val) {
      this.$emit('selection-change', val)
    },
    onSortChange (sort) {
      let sortParam = sort.prop
      if (sort.order === 'descending') {
        sortParam = '-' + sortParam
      }

      this.setPage(1)
      this.setSort(sortParam)
      this.$emit('data-change')
    },
    tableRowStyle ({row, index}) {
      return {
        // background: '#232429'
      }
    }
  },
  created () {
    this.setLoading(false)
    this.setSort('')
    this.setPage(1)
    this.setPageSize(10)
    this.setFilters({})
    if (this.fetch) {
      this.$emit('data-change')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/base";

.custom-table-wrapper {

  .el-table {
    // background: $lightPrimaryColor;

    .table-row {
      // background: $lightPrimaryColor;
    }
    .el-loading-mask {
      // background: $lightPrimaryColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTable.vue